exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bannerBox[data-v-3f461b15] .avatar-uploader .el-upload {\n  width: 2.604167rem;\n  border: 0.005208rem dashed #ddd;\n}\n.bannerBox[data-v-3f461b15] .avatar {\n  width: 2.604167rem;\n  height: 0.927083rem;\n}", ""]);

// exports
